// Formatting utilities

/* eslint-disable no-useless-escape */

import dayjs from 'dayjs';

const FMT_DATE = 'DD-MM-YYYY';
const FMT_DATE_TIME = 'DD-MM-YYYY HH:mm:ss';
const REGEXP_DATE = /^(\d{2})-(\d{2})-(\d{4})$/;
const REGEXP_PHONE = /^[+]{0,1}[0-9]{0,55}$/;

export function formatDate(str, def = str) {
    return formatDateEx(FMT_DATE, str, def);
}

export function formatDateEx(fmt, str, def = str) {
    const d = dayjs(str || '');
    return d.isValid() ? d.format(fmt) : def;
}

export function formatDateTime(str, def = str) {
    return formatDateTimeEx(FMT_DATE_TIME, str, def);
}

export function formatDateTimeEx(fmt, str, def = str) {
    const d = dayjs(str || '');
    return d.isValid() ? d.format(fmt) : def;
}

export function formatAge(str, unit = 'year') {
    const d = dayjs(str || '');
    return d.isValid() ? dayjs().diff(d, unit) : null;
}

export function formatBool(value, yes, no, nvl = null) {
    return value == null ? nvl : value ? yes : no;
}

export function isDateValid(date) {
    return REGEXP_DATE.test(date);
}

export function normalizeDateFormat(date) {
    const parts = REGEXP_DATE.exec(date);
    if (parts) {
        date = `${parts[3]}-${parts[2]}-${parts[1]}`;
    }
    return date;
}

export function isPhoneNumberValid(phoneNumber) {
    return REGEXP_PHONE.test(phoneNumber);
}
